const ONES = ["nul", "een", "twee", "drie", "vier", "vijf", "zes", "zeven", "acht", "negen", "tien",
  "elf", "twaalf", "dertien", "veertien", "vijftien", "zestien", "zeventien", "achttien", "negentien"];
const TENS = ["", "", "twintig", "dertig", "veertig", "vijftig", "zestig", "zeventig", "tachtig", "negentig"];

function below100(n) {
  if (n < 20) return ONES[n];
  const t = Math.floor(n / 10), o = n % 10;
  if (!o) return TENS[t];
  return `${ONES[o]}${ONES[o].endsWith("e") ? "ën" : "en"}${TENS[t]}`;
}

function below1000(n) {
  const h = Math.floor(n / 100), r = n % 100;
  if (!h) return below100(r);
  const head = h === 1 ? "honderd" : `${ONES[h]}honderd`;
  return r ? `${head}${below100(r)}` : head;
}

/** Bedrag in letters (NL), voor afstortingsbonnen: "tweehonderdvijftig euro en 20 cent". */
export function amountInWords(value) {
  const total = Math.round(Math.abs(Number(value) || 0) * 100);
  const euros = Math.floor(total / 100);
  const cents = total % 100;
  let text;
  if (euros === 0) text = "nul";
  else if (euros < 1000) text = below1000(euros);
  else {
    const th = Math.floor(euros / 1000), rest = euros % 1000;
    const head = th === 1 ? "duizend" : `${below1000(th)}duizend`;
    text = rest ? `${head}${below1000(rest)}` : head;
  }
  return `${text} euro${cents ? ` en ${String(cents).padStart(2, "0")} cent` : ""}`;
}
